import { makeStyles, tokens } from "@fluentui/react-components";
/**
 * Get styles for icon button
 */ export const useIconButtonStyles = makeStyles({
    root: {
        color: "inherit",
        backgroundColor: "inherit",
        borderRadius: tokens.borderRadiusXLarge
    }
});
